import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Loader } from "../loader/loader";
import ButtonLinkStyle from "./button-link-style";
import ButtonDefaultStyle from "./button-default-style";

interface IProps {
  buttonTextKey: string;
  route?: string;
  onClick?: any;
  position?: AcceptedPositions;
  id?: string;
  disabled?: boolean;
  loader?: boolean;
  inverted?: boolean;
}

interface IStyle {
  disabled?: boolean;
}

export enum AcceptedPositions {
  right = "right",
  center = "center",
  left = "left",
}

const ButtonWrapper = styled.div`
  margin: 0 auto;
  z-index: 20;
  cursor: pointer;

  &.right {
    text-align: right;
  }

  &.left {
    text-align: left;
  }

  &.center {
    text-align: center;
  }
`;

const ButtonBackground = styled.div<IStyle>`
  width: fit-content;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 4px;
  margin: 32px 0 48px;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
`;

const Button = (props: IProps) => {
  const { t } = useTranslation();
  return (
    <ButtonWrapper
      className={props.position || AcceptedPositions.center}
      data-test="continue-button"
      id="continue-button"
    >
      {props.loader && <Loader position={"fixed"} />}
      <ButtonBackground disabled={props.disabled}>
        {props.route ? (
          <ButtonLinkStyle
            data-test="continue-link-button"
            onClick={props.onClick}
            to={props.route}
            disabled={props.disabled}
            inverted={props.inverted}
          >
            {t(props.buttonTextKey)}
          </ButtonLinkStyle>
        ) : (
          <ButtonDefaultStyle
            data-test="continue-default-button"
            onClick={props.onClick}
            disabled={props.disabled}
            inverted={props.inverted}
          >
            {t(props.buttonTextKey)}
          </ButtonDefaultStyle>
        )}
      </ButtonBackground>
    </ButtonWrapper>
  );
};
export const ContinueButton = memo(Button);
